<app-search-result
  [result]="result"
  [crumbs]="crumbs">
  <app-search-result-snippet
    [snippet]="result.snippet"
    [synopsis]="result.synopsis"></app-search-result-snippet>
  <ng-content></ng-content>
</app-search-result>
